import React from 'react'
import classNames from 'classnames'
import styles from './Button.module.scss'

export type ButtonVariant = 'primary' | 'outline' | 'text'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  block?: boolean
  loading?: boolean
  className?: string
  children?: React.ReactNode
}

const CustomButton: React.FC<ButtonProps> = ({
  variant = 'primary',
  block = false,
  loading = false,
  className,
  children,
  disabled,
  ...restProps
}) => {
  const classes = classNames(
    styles.button,
    styles[variant],
    {
      [styles.block]: block,
      [styles.loading]: loading,
      [styles.disabled]: disabled || loading,
    },
    className
  )

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...restProps}
    >
      {children}
    </button>
  )
}

export default CustomButton

